var _defs, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6, _path7, _path8, _rect5, _rect6, _rect7, _rect8, _path9, _path10, _path11, _path12, _polygon, _path13, _path14, _path15, _path16, _path17, _path18, _line, _path19, _path20, _path21, _path22, _path23, _rect9, _rect10, _rect11, _rect12, _path24, _path25, _path26, _path27, _rect13, _rect14, _rect15, _rect16, _path28, _path29, _path30, _path31, _rect17, _rect18, _rect19, _rect20, _path32, _path33, _path34, _path35, _rect21, _rect22, _rect23, _rect24, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObj0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1548.6 264.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aae2c2;}.cls-2{fill:#50bd86;}.cls-3{fill:#434341;}.cls-4{fill:#fff;}.cls-5{fill:#ffdc00;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1192.84,44.58a1.42,1.42,0,0,1-.85-.28,1.43,1.43,0,0,1-.3-2l15.21-20.72a1.43,1.43,0,1,1,2.3,1.69L1194,44A1.42,1.42,0,0,1,1192.84,44.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1163.65,84.35a1.43,1.43,0,0,1-1.15-2.28l15.21-20.72A1.43,1.43,0,1,1,1180,63L1164.8,83.77A1.42,1.42,0,0,1,1163.65,84.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1176.88,47.46a1.42,1.42,0,0,1-.85-.28L1155.3,32a1.43,1.43,0,0,1,1.7-2.31l20.72,15.21a1.43,1.43,0,0,1,.31,2A1.45,1.45,0,0,1,1176.88,47.46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1216.65,76.65a1.42,1.42,0,0,1-.85-.28l-20.72-15.21a1.43,1.43,0,1,1,1.69-2.31l20.72,15.21a1.43,1.43,0,0,1-.84,2.59Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1180.09,
    y: 15.95,
    width: 2.86,
    height: 19.46,
    transform: "translate(9.77 179.5) rotate(-8.72)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1188.52,
    y: 70.9,
    width: 2.86,
    height: 19.45,
    transform: "translate(1.53 181.37) rotate(-8.72)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1149.16,
    y: 55.79,
    width: 19.46,
    height: 2.86,
    transform: "translate(4.75 176.67) rotate(-8.74)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1204.11,
    y: 47.36,
    width: 19.46,
    height: 2.86,
    transform: "translate(6.67 184.92) rotate(-8.74)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.25,168.44a1.55,1.55,0,0,1-.93-.31,1.58,1.58,0,0,1-.34-2.2l16.77-22.85a1.58,1.58,0,0,1,2.54,1.87l-16.77,22.84A1.57,1.57,0,0,1,170.25,168.44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.08,212.27a1.61,1.61,0,0,1-.93-.3,1.58,1.58,0,0,1-.34-2.21l16.76-22.84a1.58,1.58,0,0,1,2.55,1.86l-16.77,22.85A1.58,1.58,0,0,1,138.08,212.27Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.66,171.61a1.53,1.53,0,0,1-.93-.31l-22.85-16.76a1.58,1.58,0,0,1,1.87-2.55l22.84,16.77a1.58,1.58,0,0,1-.93,2.85Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.49,203.78a1.61,1.61,0,0,1-.93-.3l-22.84-16.77a1.57,1.57,0,1,1,1.86-2.54l22.85,16.76a1.58,1.58,0,0,1,.33,2.21A1.55,1.55,0,0,1,196.49,203.78Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 156.2,
    y: 136.89,
    width: 3.15,
    height: 21.44,
    transform: "translate(-20.56 25.64) rotate(-8.72)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 165.49,
    y: 197.44,
    width: 3.15,
    height: 21.44,
    transform: "translate(-29.63 27.74) rotate(-8.72)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.12,
    y: 180.8,
    width: 21.44,
    height: 3.15,
    transform: "translate(-26.16 22.29) rotate(-8.74)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 182.67,
    y: 171.5,
    width: 21.44,
    height: 3.15,
    transform: "translate(-24.04 31.38) rotate(-8.74)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635,56.45c-1.07,6.47-2,13-3.24,19.4-4.54,23.36-17.4,41.47-35.55,56.3-11.52,9.41-22.8,19.13-34.29,28.58a6.31,6.31,0,0,0-2.6,5.55q.2,12.45,0,24.9c0,1.26-.54,3-1.46,3.68-6.06,4.29-12.29,8.33-18.85,12.71-2-7.12-3.82-13.89-5.67-20.66-1-3.72-2.55-4.81-5.65-2.77-6.67,4.41-11.95,2.31-16.78-2.75-3.86-4.06-7.58-8.25-11.18-12.52a6.16,6.16,0,0,1-.69-7.79,21.51,21.51,0,0,0,1.69-3.64c1.17-3,.11-5.1-3.06-6-6.66-1.85-13.32-3.67-20.35-5.6,4.42-6.64,8.53-13,12.86-19.11.58-.83,2.27-1.2,3.46-1.22,8.05-.1,16.11-.15,24.16,0a6.43,6.43,0,0,0,5.51-2.7c12-14,24-28,36.23-41.72,14.65-16.48,33.77-24.74,54.92-29,4.62-.93,9.31-1.52,14-2.26H635ZM587.07,84.21a13.75,13.75,0,0,0-14,13.49A14,14,0,0,0,587,111.76,13.77,13.77,0,0,0,600.65,98,13.53,13.53,0,0,0,587.07,84.21Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.19,204.41c.74-3.78,1.34-7.6,2.25-11.35,2.51-10.32,7.05-19.42,16-25.93,2.25,1.66,1.92,3.2.51,5.41-5.84,9.15-7.43,19.36-7.19,30.48,11,.41,21.24-1.37,30.58-7.08,2.63-1.62,2.61-1.65,5.45.29-6.41,9.08-15.6,13.64-26,16.18-3.75.92-7.57,1.52-11.36,2.26H470.19Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.51,247.17a92.63,92.63,0,1,0-92.68-92.62A92.65,92.65,0,0,0,745.51,247.17Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M745.51,249A94.46,94.46,0,1,1,840,154.55,94.59,94.59,0,0,1,745.51,249Zm0-185.25a90.8,90.8,0,1,0,90.85,90.8A90.92,90.92,0,0,0,745.51,63.75Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "847.63 78.74 824.14 77.17 822.22 53.33 855.96 19.58 857.71 43.25 881.37 45 847.63 78.74"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M848.34,80.62l-25.89-1.74-2.12-26.25,37.15-37.16,1.94,26.07,26.07,1.93Zm-22.5-5.17,21.09,1.41,30.33-30.33L856,45,854.43,23.7,824.1,54Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M745.51,227.86a73.32,73.32,0,1,0-73.36-73.31A73.33,73.33,0,0,0,745.51,227.86Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.51,205.64a51.1,51.1,0,1,0-51.13-51.09A51.11,51.11,0,0,0,745.51,205.64Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M745.51,207.47a52.93,52.93,0,1,1,53-52.92A53,53,0,0,1,745.51,207.47Zm0-102.2a49.28,49.28,0,1,0,49.3,49.28A49.34,49.34,0,0,0,745.51,105.27Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M745.51,180.16a25.61,25.61,0,1,0-25.63-25.61A25.62,25.62,0,0,0,745.51,180.16Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M745.51,182A27.44,27.44,0,1,1,773,154.55,27.47,27.47,0,0,1,745.51,182Zm0-51.22a23.79,23.79,0,1,0,23.8,23.79A23.82,23.82,0,0,0,745.51,130.76Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 746.1,
    y1: 154.02,
    x2: 856.98,
    y2: 43.14
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M746.1,155.84a1.8,1.8,0,0,1-1.29-.53,1.82,1.82,0,0,1,0-2.59L855.69,41.85a1.82,1.82,0,0,1,2.58,2.58L747.39,155.31A1.78,1.78,0,0,1,746.1,155.84Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1209.74,224.18a1,1,0,0,1-.6-.2,1,1,0,0,1-.21-1.41l7.94-10.83a1,1,0,0,1,1.42-.21,1,1,0,0,1,.21,1.41l-7.94,10.83A1,1,0,0,1,1209.74,224.18Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1194.5,245a1,1,0,0,1-.82-1.61l8-10.83a1,1,0,0,1,1.63,1.2l-7.94,10.83A1,1,0,0,1,1194.5,245Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1201.41,225.68a1,1,0,0,1-.6-.19l-10.83-8a1,1,0,0,1-.21-1.41,1,1,0,0,1,1.41-.22l10.83,7.94a1,1,0,0,1,.21,1.42A1,1,0,0,1,1201.41,225.68Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1222.18,240.93a1,1,0,0,1-.6-.2l-10.83-7.94a1,1,0,0,1-.21-1.42,1,1,0,0,1,1.41-.22l10.83,7.95a1,1,0,0,1-.6,1.83Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1202.82,
    y: 208.96,
    width: 2.03,
    height: 10.16,
    transform: "translate(-18.54 185.03) rotate(-8.72)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1207.22,
    y: 237.66,
    width: 2.03,
    height: 10.16,
    transform: "translate(-22.84 186.03) rotate(-8.72)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1186.93,
    y: 229.5,
    width: 10.16,
    height: 2.03,
    transform: "translate(-21.18 183.71) rotate(-8.74)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1215.63,
    y: 225.1,
    width: 10.16,
    height: 2.03,
    transform: "translate(-20.18 188.02) rotate(-8.74)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1426.74,82.18a1,1,0,0,1-.6-.2,1,1,0,0,1-.21-1.41l7.94-10.83a1,1,0,0,1,1.42-.21,1,1,0,0,1,.21,1.41l-7.94,10.83A1,1,0,0,1,1426.74,82.18Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1411.5,103a1,1,0,0,1-.82-1.61l8-10.83a1,1,0,0,1,1.63,1.2l-7.94,10.83A1,1,0,0,1,1411.5,103Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1418.41,83.68a1,1,0,0,1-.6-.19L1407,75.54a1,1,0,0,1-.21-1.41,1,1,0,0,1,1.41-.22L1419,81.85a1,1,0,0,1,.21,1.42A1,1,0,0,1,1418.41,83.68Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1439.18,98.93a1,1,0,0,1-.6-.2l-10.83-7.94a1,1,0,0,1-.21-1.42,1,1,0,0,1,1.41-.22l10.83,7.95a1,1,0,0,1-.6,1.83Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1419.82,
    y: 66.96,
    width: 2.03,
    height: 10.16,
    transform: "translate(5.51 216.29) rotate(-8.72)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1424.22,
    y: 95.66,
    width: 2.03,
    height: 10.16,
    transform: "translate(1.21 217.29) rotate(-8.72)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1403.93,
    y: 87.5,
    width: 10.16,
    height: 2.03,
    transform: "translate(2.9 215.02) rotate(-8.74)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1432.63,
    y: 83.1,
    width: 10.16,
    height: 2.03,
    transform: "translate(3.9 219.33) rotate(-8.74)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.25,48.82a1.35,1.35,0,0,1-1.35-1.33l-.47-30.9a1.35,1.35,0,0,1,2.7,0l.47,30.9a1.36,1.36,0,0,1-1.33,1.37Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.14,108.11a1.35,1.35,0,0,1-1.35-1.32l-.46-30.9a1.34,1.34,0,0,1,1.33-1.37A1.31,1.31,0,0,1,333,75.85l.47,30.9a1.34,1.34,0,0,1-1.33,1.36Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.14,63.63a1.35,1.35,0,0,1,0-2.7l30.9-.47a1.37,1.37,0,0,1,1.37,1.33,1.34,1.34,0,0,1-1.33,1.37l-30.9.47Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.44,62.73a1.35,1.35,0,0,1,0-2.69l30.9-.47a1.41,1.41,0,0,1,1.37,1.33,1.36,1.36,0,0,1-1.33,1.37l-30.9.46Z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 306.37,
    y: 27.25,
    width: 2.7,
    height: 23.39,
    transform: "translate(65.48 232.67) rotate(-45.86)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 354.33,
    y: 73.79,
    width: 2.7,
    height: 23.39,
    transform: "translate(46.64 281.21) rotate(-45.86)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 297.24,
    y: 84.24,
    width: 23.39,
    height: 2.7,
    transform: "translate(32.39 247.74) rotate(-45.87)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 343.77,
    y: 36.29,
    width: 23.39,
    height: 2.7,
    transform: "translate(80.95 266.57) rotate(-45.87)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1381.56,165a1.16,1.16,0,0,1-.71-.23,1.2,1.2,0,0,1-.26-1.67l9.39-12.79a1.2,1.2,0,1,1,1.93,1.41l-9.39,12.79A1.19,1.19,0,0,1,1381.56,165Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1363.55,189.5a1.23,1.23,0,0,1-.71-.23,1.21,1.21,0,0,1-.26-1.68l9.39-12.78a1.2,1.2,0,0,1,1.93,1.41L1364.51,189A1.19,1.19,0,0,1,1363.55,189.5Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1371.71,166.74a1.17,1.17,0,0,1-.71-.24l-12.79-9.38a1.2,1.2,0,0,1,1.42-1.93l12.79,9.38a1.21,1.21,0,0,1,.25,1.68A1.18,1.18,0,0,1,1371.71,166.74Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1396.25,184.75a1.17,1.17,0,0,1-.71-.24l-12.79-9.38a1.2,1.2,0,0,1,1.42-1.93l12.79,9.38a1.21,1.21,0,0,1,.25,1.68A1.19,1.19,0,0,1,1396.25,184.75Z"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1373.37,
    y: 146.98,
    width: 2.39,
    height: 12,
    transform: "translate(-7.3 210.25) rotate(-8.72)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1378.58,
    y: 180.88,
    width: 2.39,
    height: 12,
    transform: "translate(-12.38 211.4) rotate(-8.72)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1354.61,
    y: 171.25,
    width: 12,
    height: 2.39,
    transform: "translate(-10.42 208.31) rotate(-8.72)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1388.51,
    y: 166.05,
    width: 12,
    height: 2.39,
    transform: "translate(-9.23 213.39) rotate(-8.72)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M879.29,100.15h6.21l14.35,15v-15h9.27v31.49H902.6l-14.09-15v15h-9.22Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M915,100.15h9.5v18a5.68,5.68,0,0,0,1.37,4,4.66,4.66,0,0,0,3.62,1.5,4.56,4.56,0,0,0,3.56-1.5,5.76,5.76,0,0,0,1.35-4v-18h9.49V119a12.55,12.55,0,0,1-4,9.66q-4,3.66-10.44,3.67A14.93,14.93,0,0,1,919,128.7a12.48,12.48,0,0,1-4-9.66Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M949.76,100.15h24.29v8h-14.8v3.74H972v7.74H959.25v4H974.5v8H949.76Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M978,100.15h10.35l6.93,19.21,6.79-19.21h10.35l-12.91,31.49H991Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1018.2,104.06a17.15,17.15,0,0,1,23.44,0,17.55,17.55,0,0,1,0,23.67,17.12,17.12,0,0,1-23.44,0,17.55,17.55,0,0,1,0-23.67Zm6.82,17.39a6.17,6.17,0,0,0,4.88,2.18,6.24,6.24,0,0,0,4.9-2.18,8.92,8.92,0,0,0,0-11.11,6.24,6.24,0,0,0-4.9-2.18,6.17,6.17,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M882.8,158.06a17.15,17.15,0,0,1,23.44,0,17.55,17.55,0,0,1,0,23.67,17.12,17.12,0,0,1-23.44,0,17.55,17.55,0,0,1,0-23.67Zm6.81,17.39a6.59,6.59,0,0,0,9.79,0,8.92,8.92,0,0,0,0-11.11,6.59,6.59,0,0,0-9.79,0,9,9,0,0,0,0,11.11Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M931.22,154.15a13.61,13.61,0,0,1,8.59,2.54,8,8,0,0,1,3.29,6.59,8.63,8.63,0,0,1-2.52,6.12,8.49,8.49,0,0,1,3.42,6.89,8.19,8.19,0,0,1-3.36,6.75,13.82,13.82,0,0,1-8.75,2.6h-16V154.15Zm-5.85,8v3.83h5.76a2.7,2.7,0,0,0,1.8-.57,1.71,1.71,0,0,0,.67-1.37,1.66,1.66,0,0,0-.67-1.35,2.8,2.8,0,0,0-1.8-.54Zm0,11.3v4.22h6.48a2.89,2.89,0,0,0,1.91-.58,2,2,0,0,0,.7-1.58,1.87,1.87,0,0,0-.72-1.46,2.86,2.86,0,0,0-1.89-.6Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M946.2,176.92a9.07,9.07,0,0,0,3.65.71c3,0,4.45-1.43,4.45-4.31V154.15h9.54V174.8a10.85,10.85,0,0,1-3.46,8.37,12.83,12.83,0,0,1-9,3.2q-3.74,0-5.13-1Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M969.74,154.15H994v8H979.23v3.74H992v7.74H979.23v4h15.26v8H969.74Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1017.17,162.11v23.53h-9.5V162.11h-9.49v-8h28.48v8Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1031.12,154.15h9.49v31.49h-9.49Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1044.79,154.15h10.35l6.93,19.21,6.8-19.21h10.35l-12.92,31.49h-8.5Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1085,158.06a17.16,17.16,0,0,1,23.45,0,17.55,17.55,0,0,1,0,23.67,17.13,17.13,0,0,1-23.45,0,17.55,17.55,0,0,1,0-23.67Zm6.82,17.39a6.19,6.19,0,0,0,4.88,2.18,6.26,6.26,0,0,0,4.91-2.18,9,9,0,0,0,0-11.11,6.26,6.26,0,0,0-4.91-2.18,6.19,6.19,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObj0);
export default __webpack_public_path__ + "static/media/Obj_0.a9f6886d8134f44126c5b4a8e471e099.svg";
export { ForwardRef as ReactComponent };